<template>
	<b-row class="content-element animated fadeIn" style="cursor:grab;">
    	<b-col style="padding:0">
			<div>
                <p class="p-content-select-color">Color del Texto: <input type="color" class="radio-input-color" name="textColor" :value="config.color" @change="cambiarColor($event)"> Color del fondo: <input type="color" class="radio-input-color" name="backColor" :value="config.backgroundColor" @change="cambiarBackColor($event)"></p>
                <input :id="idElement" class="input-separator"  type="text" :style="{'color':config.color,'backgroundColor':config.backgroundColor}" v-model="dataSeparator">
            </div>
    	</b-col>
    <options-element :index-element="idElement" :index-column="idColumn"></options-element> 
	</b-row>
</template>
<style>
hr.style-seven {
    overflow: visible; /* For IE */
    height: 30px;
    border-style: solid;
    border-color: #20a8d8;
    border-width: 1px 0 0 0;
    border-radius: 20px;
}
hr.style-seven:before { /* Not really supposed to work, but does */
    display: block;
    content: "";
    height: 30px;
    margin-top: -31px;
    border-style: solid;
    border-color: #20a8d8;
    border-width: 0 0 1px 0;
    border-radius: 20px;
}
.input-separator{ 
    height:50px; 
    width: 100%;
    text-align: left;
    padding-left: 20px;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0.5px;
}
.radio-input-color{
    border-radius: 100%;
    height: 20px;
    width: 20px;
    border: none;
    outline: none;
    -webkit-appearance: none;
    cursor: pointer;
}
.radio-input-color::-webkit-color-swatch-wrapper {
    padding: 0;	
}
.radio-input-color::-webkit-color-swatch {
    border: none;
    border-radius: 100%;
}
.p-content-select-color{
    margin: 20px 10px 20px 0;
    float: right;
}
</style>
<script>
import OptionsElement from './OptionsElement';
export default {
	name: 'Subtitulo',
	props:{
        content: {
            type:String,
            default: ''//no toma los valores porque está embebido--ver bien el porqué
        },
		idElement: {type:Number}, // Se obtiene posición en el arreglo matriz
        idColumn: { type:Number, default: null }, // se obtiene posición de la columna en caso de que esté posicionada en una
        configuraciones: { type: Object, default: null }
	},
	components: {
		OptionsElement
	},
	data() {
        return {
            dataSeparator: this.content,
            config: this.configuraciones
        }
    },
    methods: {
        cambiarBackColor(e){
            this.config.backgroundColor = e.target.value;
        },
        cambiarColor(e){
            this.config.color = e.target.value;
        }
    },
    watch: {
        dataSeparator: function(d) {
            this.$store.dispatch("constructor/updateContentElement", {
                indexElement: this.idElement,
                data: d,
                field: "content",
                indexColumns: this.idColumn,
            });
        },
        config: function(d) {
            this.$store.dispatch("constructor/updateContentElement", {
                indexElement: this.idElement,
                data: d,
                field: "config",
                indexColumns: this.idColumn,
            });
        }
  }
};	
</script>
